import { Components, Theme } from '@mui/material';

const muiButton: Components<Theme>['MuiButton'] = {
	styleOverrides: {
		root: {
			borderRadius: 50,
			textTransform: 'none',
		},
		contained: ({ theme }) => ({
			boxShadow:
				'0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
			backgroundColor: '#FFFFFF',
			'&.Mui-disabled': {
				backgroundColor: theme.palette.primary.main,
				opacity: 0.7,
				color: theme.palette.primary.contrastText,
			},
		}),
		containedPrimary: ({ theme }) => ({
			//button variant: contained-primary
			backgroundColor: theme.palette.button.primary,
			color: theme.palette.button.contrastText.primary,
			'&:hover': {
				backgroundColor: theme.palette.button.primary,
				color: theme.palette.button.contrastText.primary,
			},
			'&.Mui-disabled': {
				backgroundColor: theme.palette.button.primaryDisabled,
				color: theme.palette.button.contrastText.primaryDisabled,
			},
		}),
		containedSecondary: ({ theme }) => ({
			//button variant: contained-secondary
			backgroundColor: theme.palette.button.secondary,
			color: theme.palette.button.contrastText.secondary,
			'&:hover': {
				backgroundColor: theme.palette.button.secondary,
				color: theme.palette.button.contrastText.secondary,
			},
			'&.Mui-disabled': {
				backgroundColor: theme.palette.button.secondaryDisabled,
				color: theme.palette.button.contrastText.secondaryDisabled,
			},
		}),
		outlined: ({ theme }) => ({
			borderColor: theme.palette.primary.main,
			'&.Mui-disabled': {
				color: theme.palette.primary.main,
				borderColor: theme.palette.primary.main,
				opacity: 0.75,
			},
		}),
		outlinedPrimary: ({ theme }) => ({
			//button variant: contained-tertiary
			color: theme.palette.button.secondary,
			borderColor: theme.palette.button.outline,
			'&:hover': {
				borderColor: theme.palette.button.secondary,
			},
			'&.Mui-disabled': {
				color: theme.palette.button.secondaryDisabled,
				borderColor: theme.palette.button.outline,
			},
		}),
		outlinedSecondary: ({ theme }) => ({
			//button variant: contained-delete
			color: theme.palette.button.deleteColor,
			borderColor: theme.palette.button.outline,
			'&:hover': {
				borderColor: theme.palette.button.deleteColor,
			},
			'&.Mui-disabled': {
				color: theme.palette.button.deleteColorDisabled,
				borderColor: theme.palette.button.outline,
			},
		}),
		textPrimary: ({ theme }) => ({
			//button variant: inline-default
			color: theme.palette.button.secondary,
			'&:hover': {
				backgroundColor: theme.palette.button.outline,
			},
			'&.Mui-disabled': {
				color: theme.palette.button.secondaryDisabled,
			},
		}),
		textSecondary: ({ theme }) => ({
			//button variant: inline-delete
			color: theme.palette.button.deleteColor,
			'&:hover': {
				backgroundColor: theme.palette.button.outline,
			},
			'&.Mui-disabled': {
				color: theme.palette.button.deleteColorDisabled,
			},
		}),
	},
};

export default muiButton;
